import { render, staticRenderFns } from "./lwzp.vue?vue&type=template&id=33081fea&"
import script from "./lwzp.vue?vue&type=script&lang=js&"
export * from "./lwzp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports